(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function initSensenProduct(section) {
    if (!section || section.dataset.sensenProductInitialized) return;
    section.dataset.sensenProductInitialized = 'true';

    const sectionId = section.getAttribute('data-section-id');
    const variantsJsonEl = document.getElementById('SensenProductVariants-' + sectionId);
    if (!variantsJsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      return;
    }

    const dropdowns = section.querySelectorAll('[data-sensen-dropdown]');
    const inputVariantId = section.querySelector('input[name="id"]');
    const priceCurrent = section.querySelector('.sensen-pdp-price-current');
    const stickyPrice = document.getElementById('SensenStickyPrice-' + sectionId);
    const stickyVariant = document.getElementById('SensenStickyVariant-' + sectionId);
    const submitBtn = section.querySelector('button[name="add"]');
    const quantityPicker = section.querySelector('[data-sensen-quantity]');

    const textAddToCart = section.getAttribute('data-text-add-to-cart') || 'Dodaj do koszyka';
    const textSoldOut = section.getAttribute('data-text-sold-out') || 'Wyprzedane';

    function getSelectedOptions() {
      const selected = [];
      dropdowns.forEach(function (dropdown) {
        const selectedOpt = dropdown.querySelector('.sensen-select-option.is-selected');
        if (selectedOpt) {
          selected.push(selectedOpt.getAttribute('data-value'));
        }
      });
      return selected;
    }

    function updateAvailability() {
      const currentOptions = getSelectedOptions();

      dropdowns.forEach(function (dropdown, groupIdx) {
        const options = dropdown.querySelectorAll('.sensen-select-option');
        options.forEach(function (opt) {
          const rawVal = opt.getAttribute('data-value');
          const nameSpan = opt.querySelector('.option-name');
          const priceSpan = opt.querySelector('.option-price');

          const tempOptions = currentOptions.slice();
          tempOptions[groupIdx] = rawVal;

          const matched = variants.find(function (v) {
            return tempOptions.every(function (val, idx) {
              return v.options[idx] === val;
            });
          });

          if (nameSpan) nameSpan.textContent = rawVal;

          if (!matched || !matched.available) {
            opt.classList.add('is-disabled');
            opt.setAttribute('aria-disabled', 'true');
            if (priceSpan) priceSpan.textContent = '(' + textSoldOut + ')';
          } else {
            opt.classList.remove('is-disabled');
            opt.setAttribute('aria-disabled', 'false');
            if (priceSpan) priceSpan.textContent = formatMoney(matched.price);
          }
        });
      });
    }

    function getAvailableMax(matchedVariant) {
      if (!matchedVariant) return null;
      if (!matchedVariant.inventory_management || matchedVariant.inventory_policy === 'continue') {
        return null;
      }
      return matchedVariant.inventory_quantity > 0 ? matchedVariant.inventory_quantity : 1;
    }

    function updateQuantityButtons() {
      if (!quantityPicker) return;
      const minus = quantityPicker.querySelector('[data-quantity-minus]');
      const plus = quantityPicker.querySelector('[data-quantity-plus]');
      const input = quantityPicker.querySelector('.sensen-quantity-input');
      if (!minus || !plus || !input) return;

      const val = parseInt(input.value, 10) || 1;
      const maxAttr = input.getAttribute('max');
      const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;

      minus.disabled = val <= 1;
      plus.disabled = maxVal !== null ? val >= maxVal : false;
    }

    function updateSubmitButton(matchedVariant) {
      if (!submitBtn) return;

      const stickyBtn = document.getElementById('SensenStickyBtn-' + sectionId);

      const currentOptions = getSelectedOptions();
      const currentMatched =
        matchedVariant ||
        variants.find(function (variant) {
          return currentOptions.every(function (val, idx) {
            return variant.options[idx] === val;
          });
        });

      if (!currentMatched) return;

      const btnSpan = submitBtn.querySelector('span');
      const stickyBtnSpan = stickyBtn ? stickyBtn.querySelector('span') : null;

      if (!currentMatched.available) {
        submitBtn.disabled = true;
        if (stickyBtn) stickyBtn.disabled = true;
        if (btnSpan) btnSpan.textContent = textSoldOut;
        if (stickyBtnSpan) stickyBtnSpan.textContent = textSoldOut;
        return;
      }

      const qtyInput = section.querySelector('.sensen-quantity-input');
      const maxStock = getAvailableMax(currentMatched);

      if (qtyInput) {
        if (maxStock !== null) {
          qtyInput.setAttribute('max', maxStock);
          if (parseInt(qtyInput.value, 10) > maxStock) {
            qtyInput.value = maxStock;
          }
        } else {
          qtyInput.removeAttribute('max');
        }
      }

      submitBtn.disabled = false;
      if (stickyBtn) stickyBtn.disabled = false;

      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const totalPrice = currentMatched.price * qty;

      if (btnSpan) {
        if (qty > 1) {
          btnSpan.textContent = textAddToCart + ' • ' + formatMoney(totalPrice);
        } else {
          btnSpan.textContent = textAddToCart;
        }
      }
      if (stickyBtnSpan) {
        stickyBtnSpan.textContent = textAddToCart;
      }

      updateQuantityButtons();
    }

    function closeAllDropdowns() {
      document.querySelectorAll('[data-sensen-dropdown]').forEach(function (d) {
        d.classList.remove('is-open', 'open-upward');
        const trig = d.querySelector('.sensen-custom-select-trigger');
        if (trig) trig.setAttribute('aria-expanded', 'false');
      });
    }

    dropdowns.forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.sensen-custom-select-trigger');
      const selectedSpan = dropdown.querySelector('.selected-value');
      const options = Array.from(dropdown.querySelectorAll('.sensen-select-option'));
      const optionName = dropdown.getAttribute('data-option-name') || '';

      if (!trigger) return;

      function openDropdown() {
        const isOpen = dropdown.classList.contains('is-open');
        closeAllDropdowns();
        if (!isOpen) {
          const triggerRect = trigger.getBoundingClientRect();
          const spaceBelow = window.innerHeight - triggerRect.bottom;
          const spaceAbove = triggerRect.top;
          if (spaceBelow < 220 && spaceAbove > spaceBelow) {
            dropdown.classList.add('open-upward');
          } else {
            dropdown.classList.remove('open-upward');
          }
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          const curSelected = dropdown.querySelector('.sensen-select-option.is-selected') || options[0];
          if (curSelected) curSelected.focus();
        }
      }

      function chooseOption(opt) {
        if (!opt || opt.classList.contains('is-disabled')) return;
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        const val = opt.getAttribute('data-value');
        if (selectedSpan) selectedSpan.textContent = val;
        trigger.setAttribute('aria-label', optionName ? optionName + ': ' + val : val);
        dropdown.classList.remove('is-open', 'open-upward');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();

        updateAvailability();

        const currentOptions = getSelectedOptions();
        const matchedVariant = variants.find(function (variant) {
          return currentOptions.every(function (v, idx) {
            return variant.options[idx] === v;
          });
        });

        if (matchedVariant) {
          selectVariant(matchedVariant);
        }
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dropdown.classList.contains('is-open')) {
          closeAllDropdowns();
        } else {
          openDropdown();
        }
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          openDropdown();
        }
      });

      options.forEach(function (opt, idx) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          chooseOption(opt);
        });

        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            chooseOption(opt);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const next = options[idx + 1] || options[0];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = options[idx - 1] || options[options.length - 1];
            if (prev) prev.focus();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeAllDropdowns();
            trigger.focus();
          }
        });
      });
    });

    document.addEventListener('click', function () {
      closeAllDropdowns();
    });

    if (quantityPicker) {
      const minus = quantityPicker.querySelector('[data-quantity-minus]');
      const plus = quantityPicker.querySelector('[data-quantity-plus]');
      const input = quantityPicker.querySelector('.sensen-quantity-input');
      if (minus && plus && input) {
        minus.addEventListener('click', function () {
          let val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            updateSubmitButton();
          }
        });
        plus.addEventListener('click', function () {
          let val = parseInt(input.value, 10) || 1;
          const maxAttr = input.getAttribute('max');
          const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;

          if (maxVal === null || val < maxVal) {
            input.value = val + 1;
            updateSubmitButton();
          }
        });
        input.addEventListener('change', function () {
          const maxAttr = input.getAttribute('max');
          const maxVal = maxAttr ? parseInt(maxAttr, 10) : null;
          let val = parseInt(input.value, 10) || 1;

          if (val < 1) val = 1;
          if (maxVal !== null && val > maxVal) val = maxVal;
          input.value = val;

          updateSubmitButton();
        });
      }
    }

    function initStickyBarObserver() {
      const stickyBar = section.querySelector('.sensen-pdp-sticky-bar');
      if (!submitBtn || !stickyBar) return;

      if (stickyBar.parentNode !== document.body) {
        document.body.appendChild(stickyBar);
      }

      function updateChatOffset(isActive) {
        if (isActive) {
          document.body.classList.add('sensen-sticky-bar-active');
        } else {
          document.body.classList.remove('sensen-sticky-bar-active');
        }

        const chatSelectors = [
          'shopify-chat',
          '#shopify-chat',
          '.shopify-chat',
          'iframe#ShopifyChat',
          '#chat-button',
          '.crisp-client',
          '#tidio-chat',
        ];
        chatSelectors.forEach(function (sel) {
          const el = document.querySelector(sel);
          if (el) {
            el.style.transform = isActive ? 'translateY(calc(-5.6rem - env(safe-area-inset-bottom, 0px)))' : '';
            el.style.transition = 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
          }
        });
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                stickyBar.classList.add('is-visible');
                updateChatOffset(true);
              } else {
                stickyBar.classList.remove('is-visible');
                updateChatOffset(false);
              }
            });
          },
          {
            threshold: 0,
          },
        );

        observer.observe(submitBtn);
      } else {
        stickyBar.classList.add('is-visible');
        updateChatOffset(true);
      }
    }

    function initAccordions() {
      const items = section.querySelectorAll('.sensen-accordion-item');
      items.forEach(function (details) {
        const summary = details.querySelector('.sensen-accordion-header');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          if (details.open) {
            e.preventDefault();
            details.classList.add('is-closing');
            setTimeout(function () {
              details.open = false;
              details.classList.remove('is-closing');
            }, 280);
          }
        });
      });
    }

    function selectVariant(targetVariant) {
      if (!targetVariant || !targetVariant.options) return;

      dropdowns.forEach(function (dropdown, groupIdx) {
        const targetVal = targetVariant.options[groupIdx];
        const selectedSpan = dropdown.querySelector('.selected-value');
        const trigger = dropdown.querySelector('.sensen-custom-select-trigger');
        const optionName = dropdown.getAttribute('data-option-name') || '';
        const options = dropdown.querySelectorAll('.sensen-select-option');
        options.forEach(function (opt) {
          const isSelected = opt.getAttribute('data-value') === targetVal;
          opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          if (isSelected) {
            opt.classList.add('is-selected');
          } else {
            opt.classList.remove('is-selected');
          }
        });
        if (selectedSpan && targetVal) selectedSpan.textContent = targetVal;
        if (trigger && targetVal) {
          trigger.setAttribute('aria-label', optionName ? optionName + ': ' + targetVal : targetVal);
        }
      });

      if (inputVariantId) inputVariantId.value = targetVariant.id;

      const priceFormatted = formatMoney(targetVariant.price);
      if (priceCurrent) priceCurrent.textContent = priceFormatted;
      if (stickyPrice) stickyPrice.textContent = priceFormatted;

      if (targetVariant.title && targetVariant.title !== 'Default Title') {
        if (stickyVariant) {
          const variantText = targetVariant.options ? targetVariant.options.join(' • ') : targetVariant.title;
          stickyVariant.textContent = variantText;
          stickyVariant.style.display = 'inline';
        }
      } else {
        if (stickyVariant) stickyVariant.style.display = 'none';
      }

      const priceCompare = document.getElementById('SensenComparePrice-' + sectionId);
      const promoBadge = document.getElementById('SensenPromoBadge-' + sectionId);
      const omnibusWrap = document.getElementById('SensenOmnibus-' + sectionId);
      const omnibusPrice = omnibusWrap ? omnibusWrap.querySelector('.sensen-pdp-omnibus-price') : null;

      if (targetVariant.compare_at_price > targetVariant.price) {
        if (priceCompare) {
          priceCompare.textContent = formatMoney(targetVariant.compare_at_price);
          priceCompare.style.display = 'inline';
        }
        if (promoBadge) promoBadge.style.display = 'inline-block';
        if (omnibusWrap) omnibusWrap.style.display = 'block';
        if (omnibusPrice) omnibusPrice.textContent = priceFormatted;
      } else {
        if (priceCompare) priceCompare.style.display = 'none';
        if (promoBadge) promoBadge.style.display = 'none';
        if (omnibusWrap) omnibusWrap.style.display = 'none';
      }

      if (targetVariant.delivery_time) {
        const deliveryVal = section.querySelector('.sensen-pdp-delivery-val');
        if (deliveryVal) deliveryVal.textContent = targetVariant.delivery_time;
      }

      if (targetVariant.featured_media && section._sensenGallery) {
        const galleryApi = section._sensenGallery;
        const mediaId = String(targetVariant.featured_media.id);
        const thumbIndex = galleryApi.thumbBtns.findIndex(function (btn) {
          return btn.getAttribute('data-media-id') === mediaId;
        });
        if (thumbIndex >= 0) galleryApi.setActiveImage(thumbIndex);
      }

      updateAvailability();
      updateSubmitButton(targetVariant);
    }

    // Check if initial URL has ?variant=ID
    const urlParams = new URLSearchParams(window.location.search);
    const initialVariantId = urlParams.get('variant');
    if (initialVariantId) {
      const initMatched = variants.find(function (v) {
        return String(v.id) === String(initialVariantId);
      });
      if (initMatched) {
        selectVariant(initMatched);
      }
    }

    initSensenGallery(section);
    initStickyBarObserver();
    initAccordions();
    updateAvailability();
    updateSubmitButton();
  }

  function initSensenGallery(section) {
    const gallery = section.querySelector('.sensen-gallery');
    if (!gallery) return;

    const sectionId = section.getAttribute('data-section-id');
    const mainImg = gallery.querySelector('#SensenFeaturedImage');
    const expandBtn = gallery.querySelector('.sensen-gallery-expand-btn');
    const mainArea = gallery.querySelector('.sensen-gallery-main');
    const thumbBtns = Array.from(gallery.querySelectorAll('.sensen-gallery-thumb-btn'));
    const counterCurrent = gallery.querySelector('#SensenGalleryCurrent');

    const lightbox = document.getElementById('SensenLightbox-' + sectionId);
    if (!lightbox) return;

    if (lightbox.parentNode !== document.body) {
      document.body.appendChild(lightbox);
    }

    const lightboxImg = lightbox.querySelector('.sensen-lightbox-img');
    const lightboxClose = lightbox.querySelector('.sensen-lightbox-close');
    const lightboxBackdrop = lightbox.querySelector('.sensen-lightbox-backdrop');
    const lightboxCurrent = lightbox.querySelector('.sensen-lightbox-current');
    const lightboxThumbBtns = Array.from(lightbox.querySelectorAll('.sensen-lightbox-thumb-btn'));
    const lightboxStage = lightbox.querySelector('.sensen-lightbox-stage');

    let currentIndex = 0;
    let lightboxOpener = null;

    const mediaItems =
      thumbBtns.length > 0
        ? thumbBtns.map(function (btn) {
            return {
              fullSrc: btn.getAttribute('data-full-src'),
              lightboxSrc: btn.getAttribute('data-lightbox-src') || btn.getAttribute('data-full-src'),
              alt: btn.getAttribute('data-alt'),
              index: parseInt(btn.getAttribute('data-index'), 10),
            };
          })
        : [
            {
              fullSrc: mainImg ? mainImg.src : '',
              lightboxSrc: mainImg ? mainImg.getAttribute('data-lightbox-src') || mainImg.src : '',
              alt: mainImg ? mainImg.alt : '',
              index: 1,
            },
          ];

    function setActiveImage(index) {
      if (index < 0) index = mediaItems.length - 1;
      if (index >= mediaItems.length) index = 0;
      currentIndex = index;

      const item = mediaItems[currentIndex];
      if (!item) return;

      if (mainImg && item.fullSrc) {
        if (mainImg.src !== item.fullSrc) {
          mainImg.style.opacity = '0.35';
          const tempImg = new Image();
          tempImg.onload = function () {
            mainImg.removeAttribute('srcset');
            mainImg.src = item.fullSrc;
            if (item.alt) mainImg.alt = item.alt;
            mainImg.style.opacity = '1';
          };
          tempImg.src = item.fullSrc;
        }
      }

      thumbBtns.forEach(function (btn, idx) {
        if (idx === currentIndex) {
          btn.classList.add('is-active');
          const container = btn.parentElement;
          if (container && container.classList.contains('sensen-gallery-thumbs')) {
            const targetScroll = btn.offsetLeft - container.offsetWidth / 2 + btn.offsetWidth / 2;
            container.parentElement.scrollTo({ left: targetScroll, behavior: 'smooth' });
          }
        } else {
          btn.classList.remove('is-active');
        }
      });

      if (counterCurrent) counterCurrent.textContent = currentIndex + 1;
      if (mainArea) {
        const accessibleImageName = item.alt || (mainImg ? mainImg.alt : '');
        mainArea.setAttribute('aria-label', accessibleImageName + ' ' + (currentIndex + 1) + ' / ' + mediaItems.length);
      }
      if (lightboxImg && item.lightboxSrc) {
        if (lightboxImg.src !== item.lightboxSrc) {
          lightboxImg.style.opacity = '0.35';
          const tempLightboxImg = new Image();
          tempLightboxImg.onload = function () {
            lightboxImg.src = item.lightboxSrc;
            if (item.alt) lightboxImg.alt = item.alt;
            lightboxImg.style.opacity = '1';
          };
          tempLightboxImg.src = item.lightboxSrc;
        }
      }
      if (lightboxCurrent) lightboxCurrent.textContent = currentIndex + 1;

      lightboxThumbBtns.forEach(function (btn, idx) {
        if (idx === currentIndex) {
          btn.classList.add('is-active');
          const container = btn.parentElement;
          if (container) {
            const targetScroll = btn.offsetLeft - container.offsetWidth / 2 + btn.offsetWidth / 2;
            container.scrollTo({ left: targetScroll, behavior: 'smooth' });
          }
        } else {
          btn.classList.remove('is-active');
        }
      });
    }

    thumbBtns.forEach(function (btn, idx) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setActiveImage(idx);
      });
    });

    lightboxThumbBtns.forEach(function (btn, idx) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setActiveImage(idx);
      });
    });

    function openLightbox() {
      lightboxOpener = document.activeElement;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setActiveImage(currentIndex);
      window.addEventListener('keydown', handleKeyDown);
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
      if (lightboxOpener && typeof lightboxOpener.focus === 'function') lightboxOpener.focus();
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        setActiveImage(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        setActiveImage(currentIndex + 1);
      } else if (e.key === 'Tab') {
        const focusable = Array.from(
          lightbox.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'),
        ).filter(function (element) {
          return element.offsetParent !== null;
        });
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    if (mainArea) {
      var touchStartX = 0;
      var touchStartY = 0;
      var isSwiping = false;

      mainArea.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isSwiping = false;
        },
        { passive: true },
      );

      mainArea.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length !== 1) return;
          var dx = Math.abs(e.touches[0].clientX - touchStartX);
          var dy = Math.abs(e.touches[0].clientY - touchStartY);
          if (dx > 10 && dx > dy) {
            isSwiping = true;
            e.preventDefault();
          }
        },
        { passive: false },
      );

      mainArea.addEventListener(
        'touchend',
        function (e) {
          if (!isSwiping) return;
          var touchEndX = e.changedTouches[0].clientX;
          var deltaX = touchEndX - touchStartX;
          var SWIPE_THRESHOLD = 40;
          if (Math.abs(deltaX) >= SWIPE_THRESHOLD && mediaItems.length > 1) {
            if (deltaX < 0) {
              setActiveImage(currentIndex + 1);
            } else {
              setActiveImage(currentIndex - 1);
            }
          }
          setTimeout(function () {
            isSwiping = false;
          }, 50);
        },
        { passive: true },
      );

      mainArea.addEventListener('click', function () {
        if (!isSwiping) openLightbox();
      });
      mainArea.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox();
        }
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox();
      });
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);

    section._sensenGallery = { setActiveImage: setActiveImage, thumbBtns: thumbBtns };
    if (lightboxStage) {
      var lbTouchStartX = 0;
      var lbTouchStartY = 0;
      var lbIsSwiping = false;

      lightboxStage.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          lbTouchStartX = e.touches[0].clientX;
          lbTouchStartY = e.touches[0].clientY;
          lbIsSwiping = false;
        },
        { passive: true },
      );

      lightboxStage.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length !== 1) return;
          var dx = Math.abs(e.touches[0].clientX - lbTouchStartX);
          var dy = Math.abs(e.touches[0].clientY - lbTouchStartY);
          if (dx > 10 && dx > dy) {
            lbIsSwiping = true;
            e.preventDefault();
          }
        },
        { passive: false },
      );

      lightboxStage.addEventListener(
        'touchend',
        function (e) {
          if (!lbIsSwiping) return;
          var touchEndX = e.changedTouches[0].clientX;
          var deltaX = touchEndX - lbTouchStartX;
          var SWIPE_THRESHOLD = 40;
          if (Math.abs(deltaX) >= SWIPE_THRESHOLD && mediaItems.length > 1) {
            if (deltaX < 0) {
              setActiveImage(currentIndex + 1);
            } else {
              setActiveImage(currentIndex - 1);
            }
          }
          setTimeout(function () {
            lbIsSwiping = false;
          }, 50);
        },
        { passive: true },
      );

      lightboxStage.addEventListener('click', function (e) {
        if (e.target === lightboxStage && !lbIsSwiping) {
          closeLightbox();
        }
      });
    }

    const prevBtns = lightbox.querySelectorAll('.sensen-lightbox-nav.prev');
    const nextBtns = lightbox.querySelectorAll('.sensen-lightbox-nav.next');
    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveImage(currentIndex - 1);
      });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveImage(currentIndex + 1);
      });
    });
  }

  function initAllProducts() {
    const sections = document.querySelectorAll('.sensen-pdp-wrapper');
    sections.forEach(initSensenProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProducts);
  } else {
    initAllProducts();
  }

  let lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
  let stickyColumn = null;
  let resizeTimeout = null;

  const stickyState = {
    currentTop: 0,
    columnHeight: 0,
    viewportHeight: 0,
    headerOffset: 0,
    sectionPadding: 56,
    isTaller: false,
    isDesktop: false,
    ticking: false,
  };

  function readSectionPadding(rootStyle) {
    let paddingVar = '--sensen-section-padding-desktop';
    if (window.innerWidth <= 749) {
      paddingVar = '--sensen-section-padding-mobile';
    } else if (window.innerWidth <= 989) {
      paddingVar = '--sensen-section-padding-tablet';
    }
    const valStr = rootStyle.getPropertyValue(paddingVar).trim();
    if (valStr.endsWith('rem')) {
      return parseFloat(valStr) * 10;
    }
    return parseFloat(valStr);
  }

  function updateStickySizes() {
    if (!stickyColumn) {
      stickyColumn = document.querySelector('.sensen-pdp-card-panel');
    }
    if (!stickyColumn || stickyColumn.closest('.section-sensen-compact-product')) return;

    const rootStyle = getComputedStyle(document.documentElement);

    stickyState.viewportHeight = window.innerHeight;
    stickyState.columnHeight = stickyColumn.offsetHeight;
    stickyState.sectionPadding = readSectionPadding(rootStyle);

    const headerHeight = parseFloat(rootStyle.getPropertyValue('--sensen-header-h'));
    stickyState.headerOffset = headerHeight + stickyState.sectionPadding;
    stickyState.isTaller = stickyState.columnHeight > stickyState.viewportHeight - stickyState.headerOffset;
    stickyState.isDesktop = window.innerWidth >= 990;

    if (!stickyState.isDesktop) {
      stickyColumn.style.position = '';
      stickyColumn.style.top = '';
    } else {
      stickyColumn.style.position = 'sticky';
      if (!stickyState.isTaller) {
        stickyColumn.style.top = stickyState.headerOffset + 'px';
        stickyState.currentTop = stickyState.headerOffset;
      }
    }
  }

  function handleStickyScroll() {
    if (!stickyColumn || !stickyState.isDesktop) return;

    if (!stickyState.ticking) {
      stickyState.ticking = true;
      window.requestAnimationFrame(function () {
        stickyState.ticking = false;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;

        if (stickyState.isTaller) {
          const scrollDelta = scrollY - lastScrollY;
          const bottomLimit = stickyState.viewportHeight - stickyState.columnHeight - stickyState.sectionPadding;
          const topLimit = stickyState.headerOffset;

          const nextTop = Math.max(bottomLimit, Math.min(topLimit, stickyState.currentTop - scrollDelta));

          if (Math.abs(nextTop - stickyState.currentTop) > 0.5) {
            stickyState.currentTop = nextTop;
            stickyColumn.style.top = nextTop + 'px';
          }
        }

        lastScrollY = scrollY;
      });
    }
  }

  function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      updateStickySizes();
      handleStickyScroll();
    }, 150);
  }

  window.addEventListener('scroll', handleStickyScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  function initSticky() {
    updateStickySizes();
    handleStickyScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId) {
      const section = document.getElementById('SensenPDP-' + e.detail.sectionId);
      if (section) {
        delete section.dataset.sensenProductInitialized;
        initSensenProduct(section);
        updateStickySizes();
        handleStickyScroll();
      }
    }
  });
})();
